<template>
  <div class="error-input-message" v-if="error">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'BaseInputError',
  props: {
    error: { type: Boolean }
  }
}
</script>

<style lang="scss" scoped>
  .error-input-message {
    color: #ef3030;
    font-size: 12px;
    line-height: 1;
    margin-top: 8px;
  }
</style>
